import React from "react";
import { Wrapper, ImageWrapper } from "./index.styled";
import FullScreenCopy from "components/fullscreen-copy";
import Pagination from "components/pagination";
import Info from "./info";
import Features from "./features";
import FullScreenImage from "components/fullscreen-image";

const Service = ({ data }) => {
  return (
    <Wrapper>
      {data?.map((section, index) => {
        if (section.type === "fullscreenCopy") {
          return (
            <FullScreenCopy data={section} key={`service-section-${index}`} />
          );
        } else if (section.type === "info") {
          return <Info data={section} key={`service-section-${index}`} />;
        } else if (section.type === "features") {
          return <Features data={section} key={`service-section-${index}`} />;
        } else if (section.type === "fullscreenImage") {
          return (
            <ImageWrapper key={`service-section-${index}`}>
              <FullScreenImage data={section} />
            </ImageWrapper>
          );
        } else if (section.type === "pagination") {
          return <Pagination data={section} key={`service-section-${index}`} />;
        }
      })}
    </Wrapper>
  );
};

export default Service;
